module.exports = __webpack_public_path__ + "media/img/kim-fax-chat2-f10b14482d01b07f9ef099909147cdae.png";